(function () {
  var TOP_THRESHOLD = 80; // always show the nav within this many px of the top
  var MIN_DELTA = 5; // ignore sub-pixel/momentum scroll jitter

  var lastScrollY = Math.max(window.scrollY, 0);
  var ticking = false;

  function updateNavVisibility() {
    var currentScrollY = Math.max(window.scrollY, 0);
    var diff = currentScrollY - lastScrollY;

    if (currentScrollY <= TOP_THRESHOLD) {
      document.body.classList.remove('nav-hidden');
    } else if (diff > MIN_DELTA) {
      document.body.classList.add('nav-hidden');
    } else if (diff < -MIN_DELTA) {
      document.body.classList.remove('nav-hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateNavVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );
})();